/**
 * 国家ID
 */
export enum CountryID {
  /**
   * 印尼
   */
  ID = 1,
  /**
   * 马来
   */
  MY,
  /**
   * 菲律宾
   */
  PH,
  /**
   * 越南
   */
  VN,
  /**
   * 中国
   */
  CHN,
  /**
   * 德国
   */
  DE,
  /**
   * 西班牙
   */
  ES,
  /**
   * 法国
   */
  FR,
  /**
   * 意大利
   */
  IT,
  /**
   * 比利时
   */
  BE,
  /**
   * 波兰
   */
  PL = 26,
}

/**
 * 国家 Code
 */
export enum CountryCode {
  /**
   * 印尼
   */
  ID = "ID",
  /**
   * 马来
   */
  MY = "MY",
  /**
   * 菲律宾
   */
  PH = "PH",
  /**
   * 越南
   */
  VN = "VN",
  /**
   * 中国
   */
  CHN = "CHN",
  /**
   * 德国
   */
  DE = "DE",
  /**
   * 西班牙
   */
  ES = "ES",
  /**
   * 法国
   */
  FR = "FR",
  /**
   * 意大利
   */
  IT = "IT",
  /**
   * 比利时
   */
  BE = "BE",
  /**
   * 波兰
   */
  PL = "PL",
}

/**
 * 语言ID，和i18n对应
 */
export enum LanguageId {
  /**
   * 印尼语
   */
  in = 123,
  /**
   * 英语
   */
  en = 102,
  /**
   * 马来语
   */
  ms = 141,
  /**
   * 越南语
   */
  vi = 142,
  /**
   * 中文
   */
  zh = 100,
  /**
   * 德语
   */
  de = 150,
  /**
   * 西班牙语
   */
  es = 151,
  /**
   * 法语、比利时也用法语
   */
  fr = 152,
  /**
   * 意大利
   */
  it = 153,
  /**
   * 波兰
   */
  pl = 154,
}

/**
 * 语言码，和i18n对应
 */
export enum LanguageCode {
  /**
   * 印尼语
   */
  in = "in",
  /**
   * 英语
   */
  en = "en",
  /**
   * 马来语
   */
  ms = "ms",
  /**
   * 越南语
   */
  vi = "vi",
  /**
   * 中文
   */
  zh = "zh",
  /**
   * 德语
   */
  de = "de",
  /**
   * 西班牙语
   */
  es = "es",
  /**
   * 法语、比利时也用法语
   */
  fr = "fr",
  /**
   * 意大利
   */
  it = "it",
  /**
   * 波兰
   */
  pl = "pl",
}

/**
 * 货币符号，不同国家货币符号不一样
 */
export enum CurrencyCode {
  /**
   * 印尼货币
   */
  ID = "Rp",
  /**
   * 马来货币
   */
  MY = "RM",
  /**
   * 菲律宾货币
   */
  PH = "₱",
  /**
   * 越南货币
   */
  VN = "₫",
  /**
   * 人名币
   */
  CHN = "RMB",
  /**
   * 德国
   */
  DE = "€",
  /**
   * 西班牙
   */
  ES = "€",
  /**
   * 法国
   */
  FR = "€",
  /**
   * 意大利
   */
  IT = "€",
  /**
   * 比利时
   */
  BE = "€",
  /**
   * 波兰
   */
  PL = "zł",
}

/**
 * 货币id
 */
export enum CurrencyCodeId {
  /**
   * 马来货币
   */
  "RM" = 3,
  /**
   * 印尼货币
   */
  "Rp",
  /**
   * 菲律宾货币
   */
  "₱",
  /**
   * 越南货币
   */
  "₫",
  /**
   * 人名币
   */
  "RMB",
  /**
   * 欧元
   */
  "€",
  /**
   * 波兰兹罗提
   */
  "zł",
}

/**
 * 国家对应的手机号码前缀
 */
export enum CountryPhoneCode {
  /**
   * 印尼
   */
  ID = "62",
  /**
   * 马来
   */
  MY = "60",
  /**
   * 菲律宾
   */
  PH = "63",
  /**
   * 越南
   */
  VN = "84",
  /**
   * 中国
   */
  CHN = "86",
  /**
   * 德国
   */
  DE = "49",
  /**
   * 西班牙
   */
  ES = "34",
  /**
   * 法国
   */
  FR = "33",
  /**
   * 意大利
   */
  IT = "39",
  /**
   * 比利时
   */
  BE = "32",
  /**
   * 波兰
   */
  PL = "48",
}

/**
 * 国家名称
 */
export enum CountryNameAlias {
  /**
   * 印尼
   */
  ID = "印尼",
  /**
   * 马来
   */
  MY = "马来西亚",
  /**
   * 菲律宾
   */
  PH = "菲律宾",
  /**
   * 越南
   */
  VN = "越南",
  /**
   * 中国
   */
  CHN = "中国",
  /**
   * 德国
   */
  DE = "德国",
  /**
   * 西班牙
   */
  ES = "西班牙",
  /**
   * 法国
   */
  FR = "法国",
  /**
   * 意大利
   */
  IT = "意大利",
  /**
   * 比利时
   */
  BE = "比利时",
  /**
   * 波兰
   */
  PL = "波兰",
}

/**
 * 国家英文名
 */
export enum CountryEnName {
  /**
   * 印尼
   */
  ID = "Indonesia",
  /**
   * 马来
   */
  MY = "Malaysia",
  /**
   * 菲律宾
   */
  PH = "Philippines",
  /**
   * 越南
   */
  VN = "Vietnam",
  /**
   * 中国
   */
  CHN = "China",
  /**
   * 德国
   */
  DE = "Germany",
  /**
   * 西班牙
   */
  ES = "Spain",
  /**
   * 法国
   */
  FR = "France",
  /**
   * 意大利
   */
  IT = "Italy",
  /**
   * 比利时
   */
  BE = "Belgium",
  /**
   * 波兰
   */
  PL = "Poland",
}
